
export const howToVideosNav = [
    {url: '/how-to-videos', label: 'How-To Videos Management', key: 'howToVideos.index', permissions: []},
]